import { useEffect, useRef, useState } from 'react'

export default function AnimatedCard({ children, className = '', delay = '0s', ...props }) {
  const cardRef = useRef(null)
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setTimeout(() => setIsVisible(true), parseFloat(delay) * 1000)
        }
      },
      { threshold: 0.1 }
    )

    if (cardRef.current) {
      observer.observe(cardRef.current)
    }

    return () => observer.disconnect()
  }, [delay])

  return (
    <div
      ref={cardRef}
      className={`
        glass-card p-6 transition-all duration-700 transform hover:scale-105 hover:shadow-2xl group cursor-pointer
        ${isVisible ? 'animate-slide-up opacity-100' : 'opacity-0 translate-y-8'}
        ${className}
      `}
      {...props}
    >
      <div className="relative">
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/5 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 transform -skew-x-12 group-hover:animate-shine"></div>
        {children}
      </div>
    </div>
  )
}